import type { EventCategory } from './base';

/** Where a booking CTA sits; the same strings as `ctaLocation` on LANDING_CTA_CLICKED. */
export type BookingCtaLocation =
  | 'navbar_desktop'
  | 'navbar_mobile'
  | 'hero_primary'
  | 'interim_minimal'
  | 'interim_full'
  | 'pilot_section'
  | 'faq-footer'
  | 'final_main'
  | 'final_calendly_link'
  | 'waste_calculator_cta'
  | 'waste_calculator_footer';

export const LandingEvents = {
  // Existing CTA tracking
  LANDING_CTA_CLICKED: {
    categories: ['marketing'] as EventCategory[],
    properties: {
      ctaLocation: '' as string,
      ctaText: '' as string,
      ctaType: 'primary' as 'primary' | 'secondary',
      section: '' as string,
      destinationUrl: '' as string,
      language: '' as string,
    },
  },

  // One event per click on any booking CTA (BookingLink), used to count bookings per campaign
  LANDING_BOOKING_CLICKED: {
    categories: ['marketing'] as EventCategory[],
    properties: {
      ctaLocation: '' as BookingCtaLocation,
      destinationType: 'web' as 'web' | 'mailto',
      language: '' as string,
    },
  },

  // Video Engagement (consolidated)
  LANDING_VIDEO_INTERACTION: {
    categories: ['marketing'] as EventCategory[],
    properties: {
      action: '' as
        | 'modal_opened'
        | 'played'
        | 'paused'
        | 'completed'
        | 'modal_closed'
        | 'milestone_reached',
      videoId: '' as string,
      section: '' as string,
      playbackPosition: 0 as number,
      watchDuration: 0 as number,
      completionPercentage: 0 as number,
      language: '' as string,
    },
  },

  // FAQ Interactions (2 events)
  LANDING_FAQ_EXPANDED: {
    categories: ['marketing'] as EventCategory[],
    properties: {
      questionId: '' as string,
      questionKey: '' as string,
      questionIndex: 0 as number,
      section: '' as string,
      language: '' as string,
    },
  },
  LANDING_FAQ_CTA_CLICKED: {
    categories: ['marketing'] as EventCategory[],
    properties: {
      ctaLocation: '' as string,
      ctaText: '' as string,
      section: '' as string,
      destinationUrl: '' as string,
      language: '' as string,
    },
  },

  // Section Visibility (2 events)
  LANDING_SECTION_VIEWED: {
    categories: ['marketing'] as EventCategory[],
    properties: {
      section: '' as string,
      viewportPercentage: 0 as number,
      timeToView: 0 as number,
      language: '' as string,
    },
  },
  LANDING_SCROLL_DEPTH_REACHED: {
    categories: ['marketing'] as EventCategory[],
    properties: {
      depth: 0 as number, // 25, 50, 75, 100
      maxDepth: 0 as number,
      timeToReach: 0 as number,
      language: '' as string,
    },
  },

  // Newsletter Subscription
  LANDING_NEWSLETTER_SUBSCRIBED: {
    categories: ['marketing', 'conversion'] as EventCategory[],
    properties: {
      source: '' as string, // 'footer', 'popup', etc.
      language: '' as string,
    },
  },
} as const;
